<!-- 进场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KPGDYCO",
                "blacklistSeq": "209",
                "carLicenseNumber": "粤K12345",
                "owner": "张三",
                "addBy": "李四",
                "addTime": "2018-04-14 00:00:00",
                "blacklistForeverFlag": "0",
                "reason": "欠费",
                "remark1": "",
                "remark2": "",
                "isDeleted": "0",
                "billNumber": "",
                "customVipSeq": "79",
                "customVipCode": "546",
                "customVipName": "自动欠费黑名单",
                "timeperiodList": [
                    {
                        "startTime": "2018-04-14 00:00:00",
                        "endTime": "2018-04-14 23:59:59"
                    }
                ]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报车辆黑名单信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportBlacklistRecord",
                precondition: "VEMS 2.16及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'blacklistSeq', info2: '是', info3: 'Integer', info4: '黑名单在vems的唯一序列号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '黑名单车牌号' },
                        { info1: 'owner', info2: '是', info3: 'String', info4: '车主姓名' },
                        { info1: 'addBy', info2: '是', info3: 'String', info4: '添加人' },
                        { info1: 'addTime', info2: '是', info3: 'String', info4: '添加时间' },
                        { info1: 'blacklistForeverFlag', info2: '是', info3: 'Integer', info4: '黑名单永久有效标识(0-关闭，1开启)' },
                        { info1: 'reason', info2: '否', info3: 'String', info4: '黑名单理由' },
                        { info1: 'remark1', info2: '否', info3: 'String', info4: '备注1' },
                        { info1: 'remark2', info2: '否', info3: 'String', info4: '备注2' },
                        { info1: 'isDeleted', info2: '是', info3: 'Integer', info4: '是否逻辑删除（0未删除，1删除）' },
                        { info1: 'billNumber', info2: '否', info3: 'String', info4: '唯一流水号,该流水号为线上同步黑名单时存在,但是线下的添加的却没有' },
                        { info1: 'customVipSeq', info2: '是', info3: 'Integer', info4: '黑名单vip类型序号' },
                        { info1: 'customVipCode', info2: '否', info3: 'String', info4: '黑名单vip自定义编码,如果有便填写' },
                        { info1: 'customVipName', info2: '是', info3: 'String', info4: '黑名单名称' },
                        { info1: 'timeperiodList', info2: '否', info3: 'JSONArray', info4: '黑名单时间列表,blacklistForeverFlag为0,则该数组不为空,否则,为[]' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                },{
                    titleName: 'timeperiodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '黑名单开始时间	yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '黑名单结束时间	yyyy-MM-dd HH:mm:ss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportBlacklistData.vue